module.exports = __webpack_public_path__ + "img/sea-4.df57118c.jpg";